<template :class="classes()">
  <Modal :open="isOpen" @close="closeModal" :headline="$t('home.404.headline')" size="s">
    <Copy centered responsive size="s">
      {{ isCareLevelError ? $t('careLevelCalculator.404.copy') : $t('home.404.copy') }}
      <a v-if="!isCareLevelError" :href="`mailto:${CONTACT_EMAIL}`">
        {{ CONTACT_EMAIL }}
      </a>
    </Copy>

    <div class="u-margin__vertical--3">
      <Divider />
    </div>
    <Copy element="div" centered>
      <Button label="Schließen" @click="closeModal" small />
    </Copy>
  </Modal>
</template>

<script>
import Modal from '@/components/Modal/Modal';
import Copy from '@/objects/Copy/Copy';
import Divider from '@/objects/Divider/Divider';
import Button from '@/objects/Button/Button';

import { CONTACT_EMAIL } from '@/constants/generics';

export default {
  name: 'ErrorModal404',
  components: { Button, Divider, Copy, Modal },
  props: {
    isCareLevelError: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      CONTACT_EMAIL,
      isOpen: true,
      el: 'c-errorModal404',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },
  methods: {
    closeModal() {
      this.isOpen = false;
      this.$emit('closeErrorModal');
    },
  },
};
</script>
